import type { OfficialResource } from "@shikaku/shared";

export const officialResources: OfficialResource[] = [
  {
    id: "pastIndex",
    title: "公式過去問一覧",
    subtitle: "ECCJの過去問ページをブラウザで開く",
    url: "https://www.eccj.or.jp/mgr1/test_past/index.html",
  },
  {
    id: "r06",
    title: "令和6年度",
    subtitle: "課目I・熱分野・電気分野の令和6年度問題へ",
    url: "https://www.eccj.or.jp/mgr1/test_past/index.html#r06",
  },
  {
    id: "r05",
    title: "令和5年度",
    subtitle: "課目I・熱分野・電気分野の令和5年度問題へ",
    url: "https://www.eccj.or.jp/mgr1/test_past/index.html#r05",
  },
  {
    id: "r04",
    title: "令和4年度",
    subtitle: "課目I・熱分野・電気分野の令和4年度問題へ",
    url: "https://www.eccj.or.jp/mgr1/test_past/index.html#r04",
  },
  {
    id: "guide",
    title: "受験の手引",
    subtitle: "最新の受験案内・注意事項を確認",
    url: "https://www.eccj.or.jp/mgr1/test_guide/index.html",
  },
  {
    id: "examTop",
    title: "公式トップ",
    subtitle: "資格概要・試験部のお知らせを見る",
    url: "https://www.eccj.or.jp/mgr1/",
  },
];
